import React, { useEffect, useState } from 'react';
import { withTranslations, WithTranslationsProps } from 'react-utilities';
import { Loading } from 'react-style-guide';
import { playButtonTranslationConfig } from '../../../translation.config';
import playButtonService from '../services/playButtonService';
import { PlayButton as PlayButtonComponent, PurchaseButton, Error } from '../components/PlayButton';
import {
  TErrorComponent,
  TPlayComponent,
  TLoadingComponent,
  TPurchaseComponent,
  TPlayabilityStatus
} from '../types/playButtonTypes';

export function PlayButton({
  translate,
  universeId,
  placeId,
  loadingComponent,
  errorComponent,
  purchaseComponent,
  playComponent
}: {
  universeId: number;
  placeId: number;
  loadingComponent?: TLoadingComponent;
  errorComponent?: TErrorComponent;
  purchaseComponent?: TPurchaseComponent;
  playComponent?: TPlayComponent;
} & WithTranslationsProps): JSX.Element {
  const [playabilityStatus, setPlayabilityStatus] = useState<TPlayabilityStatus | undefined>(
    undefined
  );

  const fetchPlayabilityStatus = async () => {
    setPlayabilityStatus(undefined);
    try {
      const response = await playButtonService.getPlayabilityStatus([universeId]);
      setPlayabilityStatus(response.playabilityStatus);
    } catch (e) {
      setPlayabilityStatus(TPlayabilityStatus.TemporarilyUnavailable);
    }
  };

  useEffect(() => {
    // eslint-disable-next-line no-void
    void fetchPlayabilityStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  switch (playabilityStatus) {
    case undefined:
      return !loadingComponent ? <Loading /> : loadingComponent();
    case TPlayabilityStatus.Playable:
    case TPlayabilityStatus.GuestProhibited:
      return (
        <PlayButtonComponent
          placeId={placeId}
          status={playabilityStatus}
          playComponent={playComponent}
        />
      );
    case TPlayabilityStatus.PurchaseRequired:
      return (
        <PurchaseButton
          translate={translate}
          onPurchaseSuccess={() => setPlayabilityStatus(TPlayabilityStatus.Playable)}
          universeId={universeId}
          placeId={placeId}
          purchaseComponent={purchaseComponent}
          loadingComponent={loadingComponent}
        />
      );
    default:
      return (
        <Error
          playabilityStatus={playabilityStatus}
          translate={translate}
          errorComponent={errorComponent}
        />
      );
  }
}

PlayButton.defaultProps = {
  loadingComponent: undefined,
  errorComponent: undefined,
  purchaseComponent: undefined,
  playComponent: undefined
};

export default Object.assign(withTranslations(PlayButton, playButtonTranslationConfig), {
  PlayabilityStatus: TPlayabilityStatus
});
